const emptySummary = {
  totalConsumption: 0,
  averageConsumption: 0,
  peakConsumption: 0,
  peakTimestamp: null,
  lowestConsumption: 0,
  lowestTimestamp: null,
};

const findExtremeDataPoint = (dataPoints, direction) =>
  dataPoints.reduce((extreme, point) => {
    if (!Number.isFinite(point.sum)) return extreme;

    if (
      !extreme ||
      (direction === 'max' ? point.sum > extreme.sum : point.sum < extreme.sum)
    ) {
      return { sum: point.sum, timestamp: point.timestamp };
    }

    return extreme;
  }, null);

export const calculateMeterSummaryKpis = (
  meterSummaries,
  unitIds,
  aggregatedData,
) => {
  if (unitIds === 'none') {
    return emptySummary;
  }

  const summaries = Array.isArray(meterSummaries) ? meterSummaries : [];
  const selectedIds = unitIds
    ? new Set(unitIds.split(',').map((id) => Number(id) || id))
    : null;
  const selectedSummaries = selectedIds
    ? summaries.filter((summary) => selectedIds.has(summary.UnitId))
    : summaries;
  const peak = Array.isArray(aggregatedData)
    ? findExtremeDataPoint(aggregatedData, 'max')
    : null;
  const lowest = Array.isArray(aggregatedData)
    ? findExtremeDataPoint(aggregatedData, 'min')
    : null;

  const summaryTotals = selectedSummaries.reduce(
    (totals, summary) => {
      totals.totalConsumption += summary.TotalValue ?? 0;
      totals.peakConsumption += summary.MaxValue ?? 0;
      totals.lowestConsumption += summary.MinValue ?? 0;
      return totals;
    },
    { ...emptySummary },
  );

  // MeanValue is the mean of the hourly data, so the average per aggregation
  // bucket is derived from the bucket sums instead.
  const bucketSums = Array.isArray(aggregatedData)
    ? aggregatedData.map((point) => point.sum).filter(Number.isFinite)
    : [];
  const averageConsumption = bucketSums.length
    ? bucketSums.reduce((acc, sum) => acc + sum, 0) / bucketSums.length
    : 0;

  return {
    ...summaryTotals,
    averageConsumption,
    peakConsumption: peak?.sum ?? summaryTotals.peakConsumption,
    peakTimestamp: peak?.timestamp ?? null,
    lowestConsumption: lowest?.sum ?? summaryTotals.lowestConsumption,
    lowestTimestamp: lowest?.timestamp ?? null,
  };
};
